import { createBEMClasses } from '@/utils/classname';

import { StepperNumberItem, StepperNumberItemProps } from './StepperNumberItem/StepperNumberItem';

import './StepperNumber.css';

export interface StepperNumberProps {
  stepperNumberItems: StepperNumberItemProps[];
}

const { block, element } = createBEMClasses('stepper-number');
const renderStepperNumberItems = (items: StepperNumberItemProps[]) => {
  return items.map((el, i) => {
    const { number, label, status } = el;

    if (i < items.length - 1) {
      return (
        <span key={i}>
          <StepperNumberItem number={number} label={label} status={status} />
          <span className={element('progress-line', { completed: status === 'completed' })} />
        </span>
      );
    } else {
      return <StepperNumberItem key={i} number={number} label={label} status={status} />;
    }
  });
};

export const StepperNumber = ({ stepperNumberItems }: StepperNumberProps) => {
  return <div className={block()}>{renderStepperNumberItems(stepperNumberItems)}</div>;
};
